<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-progress-linear
          v-show="loading"
          :indeterminate="true"
          color="primary"
        ></v-progress-linear>
        <v-card-title primary-title>Email: {{ email }}</v-card-title>
        <v-card-text>
          <h3>Status: {{ status.status_string }}</h3>
          <div>Name: {{ student.name }}</div>
          <div>fondi ID: {{ student.fondi_id }}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="editStatusEnabled"
            color="success"
            :disabled="loading || isActive"
            @click="activate"
            >Activate</v-btn
          >
          <v-btn
            v-if="editStatusEnabled"
            color="error"
            :disabled="loading || isExpired"
            @click="expire"
            >Expire</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="gley" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  RequestStudyGroups,
  ActiveStudentStatus,
  ExpiredStudentStatus,
} from '../../../requests/study-program/groups';

export default {
  props: {
    editStatusEnabled: {
      type: Boolean,
      default: () => true,
    },
    onUpdateStudentStatus: {
      type: Function,
      default: (studentId, statusString) =>
        console.log({ studentId: studentId, statusString: statusString }),
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      studyGroupId: 0,
      email: '',
      student: {},
      status: {},
    };
  },
  computed: {
    isActive() {
      return this.status.status === ActiveStudentStatus;
    },
    isExpired() {
      return this.status.status === ExpiredStudentStatus;
    },
  },
  methods: {
    async open(studyGroupId, studentId, email) {
      this.studyGroupId = studyGroupId;
      this.email = email;
      this.student = {};
      this.status = {};

      this.dialog = true;
      this.loading = true;

      const res = await RequestStudyGroups.showStudent(studyGroupId, studentId);
      if (!res.student || !res.status) {
        return;
      }

      this.student = res.student;
      this.status = res.status ? res.status : {};

      this.loading = false;
    },

    async activate() {
      const result = window.confirm(
        `このユーザー（Email: ${this.student.email}）をActive状態にしてもよろしいですか？\n※これ以降Trial状態には戻せません`
      );
      if (!result) return;

      const res = await RequestStudyGroups.activateStudentStatus(
        this.studyGroupId,
        this.student.id
      );

      this.status = res.status;

      this.onUpdateStudentStatus(this.student.id, res.status.status_string);
    },

    async expire() {
      const result = window.confirm(
        `このユーザー（Email: ${this.student.email}）をExpired状態にしてもよろしいですか？\n※これ以降Trial状態には戻せません`
      );
      if (!result) return;

      const res = await RequestStudyGroups.expireStudentStatus(this.studyGroupId, this.student.id);

      this.status = res.status;

      this.onUpdateStudentStatus(this.student.id, res.status.status_string);
    },
  },
};
</script>
